import {
  ACTIVE_ORGANISATION_REQUEST_HEADER,
  getActiveOrganisationId,
} from './organisationContext';

export function createOrganisationContextFetch(
  fetchImplementation,
  getOrganisationId = getActiveOrganisationId
) {
  if (typeof fetchImplementation !== 'function') {
    throw new Error('A fetch implementation is required.');
  }

  return (input, init = {}) => {
    const headers = new Headers(init.headers);
    const organisationId = getOrganisationId();

    if (organisationId) {
      headers.set(ACTIVE_ORGANISATION_REQUEST_HEADER, organisationId);
    } else {
      headers.delete(ACTIVE_ORGANISATION_REQUEST_HEADER);
    }

    return fetchImplementation(input, { ...init, headers });
  };
}
